var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMilkBottle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 7H8.00478C8.06892 6.16089 8.77009 5.5 9.62563 5.5H9.73223C10.6652 5.5 11.3819 4.67364 11.25 3.75L11.1414 2.98995C11.0668 2.46746 11.4722 2 12 2C12.5278 2 12.9332 2.46746 12.8586 2.98995L12.75 3.75C12.6181 4.67364 13.3348 5.5 14.2678 5.5H14.3744C15.2299 5.5 15.9311 6.16089 15.9952 7H16C16.5523 7 17 7.44772 17 8C17 8.55228 16.5523 9 16 9C16.5523 9 17 9.44771 17 10V11.25H15C14.5858 11.25 14.25 11.5858 14.25 12C14.25 12.4142 14.5858 12.75 15 12.75H17V14.25H15C14.5858 14.25 14.25 14.5858 14.25 15C14.25 15.4142 14.5858 15.75 15 15.75H17V17.25H15C14.5858 17.25 14.25 17.5858 14.25 18C14.25 18.4142 14.5858 18.75 15 18.75H17V21C17 21.5523 16.5523 22 16 22H8C7.44772 22 7 21.5523 7 21V10C7 9.44771 7.44772 9 8 9C7.44772 9 7 8.55228 7 8C7 7.44772 7.44772 7 8 7Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMilkBottle);
export default __webpack_public_path__ + "static/media/milk-bottle.8b9990663332c1fedc2d8d407ee85803.svg";
export { ForwardRef as ReactComponent };